import {AfterViewInit, Component} from '@angular/core';
import {
    ControlService,
    IconService,
    MenuService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'on-off',
    templateUrl: './on-off.component.html',
    styleUrls: ['./on-off.component.scss']
})
export class OnOffComponent implements AfterViewInit{
    constructor(
        public control: ControlService,
        private icon: IconService,
        private menu: MenuService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    returnValue(value: 0 | 1 | 2 | 3): void {
        this.control.pin = this.menu.getParentPin(this.control.elementVal.getValue());
        this.control.returnVal(value);
    }
}
